import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import clsx from 'clsx';

function Heading({
  children,
  as,
  isUpperCase,
  align,
  noMargin,
  color,
  ...rest
}) {
  const classNames = useMemo(
    () =>
      clsx({
        'text-[22px] font-bold text-black md:text-2xl': as === 'h1',
        'text-lg font-semibold text-night-rider': as === 'h2',
        'text-base font-semibold text-night-rider': as === 'h3',
        'text-sm font-semibold text-night-rider': as === 'h4',
        'text-sm text-dark-gray': as === 'h5',

        'uppercase': isUpperCase,

        'text-center': align === 'center',
        'text-right': align === 'right',
        'text-left': align === 'left',

        'm-0': noMargin
      }),
    [as, isUpperCase, align, noMargin]
  );

  switch (as) {
    case 'h2':
      return (
        <h2 className={classNames} style={color ? { color } : null} {...rest}>
          {children}
        </h2>
      );
    case 'h3':
      return (
        <h3 className={classNames} style={color ? { color } : null} {...rest}>
          {children}
        </h3>
      );
    case 'h4':
      return (
        <h4 className={classNames} style={color ? { color } : null} {...rest}>
          {children}
        </h4>
      );
    case 'h5':
      return (
        <h5 className={classNames} style={color ? { color } : null} {...rest}>
          {children}
        </h5>
      );
    default:
      return (
        <h1 className={classNames} style={color ? { color } : null} {...rest}>
          {children}
        </h1>
      );
  }
}

Heading.propTypes = {
  as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5']).isRequired,
  isUpperCase: PropTypes.bool,
  align: PropTypes.oneOf(['center', 'right', 'left']),
  noMargin: PropTypes.bool,
  color: PropTypes.string
};

Heading.defaultProps = {
  isUpperCase: false,
  align: 'left',
  noMargin: false,
  color: undefined
};

export default Heading;
